import { $, GraphQLTypes, InputType, Selector } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';

const trackingThematiqueSelector = Selector('TrackingThematique')({
  connectionId: true,
  createdAt: true,
  site: true,
  thematique: true,
  terminatedAt: true,
  time: true,
  id: true,
  currentActivityOrder: true,
  connection: {
    id: true,
    sessionUuid: true,
  },
});

const rushHourSelector = Selector('RushHour')({
  count: true,
  hour: true,
});

const siteRushHourSelector = Selector('SiteRushHour')({
  site: true,
  rushHours: rushHourSelector,
});

// Response
const responseSelector = Selector('Response')({
  activityOrder: true,
  questionCountCorrect: true,
  questionCountIncorrect: true,
});

const trackingPassedTimeByThematiqueSelector = Selector(
  'TrackingPassedTimeByThematique'
)({
  passedTime: true,
  questionCount: true,
  questionCountCorrect: true,
  questionCountIncorrect: true,
  site: true,
  thematique: true,
  viewCount: true,
  viewCountFinished: true,
  viewCountLeft: true,
  responses: responseSelector,
});

const trackingStatsSelector = Selector('TrackingsStats')({
  connectionCount: true,
  passedTime: true,
  siteRushHour: siteRushHourSelector,
  trackingsByThematique: trackingPassedTimeByThematiqueSelector,
});

const trackingCommonStatsSelector = Selector('TrackingsCommonStats')({
  connectionCount: true,
  passedTime: true,
  siteRushHour: siteRushHourSelector,
});

const trackingThematiqueInfoSelector = Selector('TrackingThematiqueInfo')({
  id: true,
  site: true,
  thematique: true,
  connection: {
    id: true,
    sessionUuid: true,
  },
  currentActivityOrder: true,
  time: true,
  trackings: {
    id: true,
    answers: true,
    isCorrect: true,
    activityOrder: true,
    activityType: true,
    time: true,
  },
});

export const GQL_CREATE_TRACKING_THEMATIQUE = typedGql('mutation')({
  createOrUpdateTrackingThematique: [
    {
      createTrackingThematiqueInput: {
        connectionId: $('connectionId', 'Int'),
        sessionUuid: $('sessionUuid', 'String!'),
        site: $('site', 'Site!'),
        thematique: $('thematique', 'Thematique!'),
        trackingThematiqueId: $('trackingThematiqueId', 'Int'),
        currentActivityOrder: $('currentActivityOrder', 'Int!'),
      },
    },
    trackingThematiqueInfoSelector,
  ],
});

export const GQL_UPDATE_TRACKING_THEMATIQUE = typedGql('mutation')({
  updateTrackingThematique: [
    {
      updateTrackingThematiqueInput: {
        id: $('id', 'Int!'),
        time: $('time', 'Int'),
        currentActivityOrder: $('currentActivityOrder', 'Int'),
        terminatedAt: $('terminatedAt', 'DateTime'),
      },
    },
    true,
  ],
});

export const GQL_STATS = typedGql('query')({
  getStats: [
    {
      filterStatsInput: {
        startDate: $('startDate', 'DateTime'),
        endDate: $('endDate', 'DateTime'),
      },
    },
    trackingStatsSelector,
  ],
});

export const GQL_COMMON_STATS = typedGql('query')({
  getStats: [
    {
      filterStatsInput: {
        startDate: $('startDate', 'DateTime'),
        endDate: $('endDate', 'DateTime'),
      },
    },
    trackingCommonStatsSelector,
  ],
});

export type StoredTrackingStats = InputType<
  GraphQLTypes['TrackingsStats'],
  typeof trackingStatsSelector
>;

export type StoredTrackingCommonStats = InputType<
  GraphQLTypes['TrackingsCommonStats'],
  typeof trackingCommonStatsSelector
>;
export type StoredTrackingThematique = InputType<
  GraphQLTypes['TrackingThematique'],
  typeof trackingThematiqueSelector
>;

export type StoredTrackingInfoThematique = InputType<
  GraphQLTypes['TrackingThematiqueInfo'],
  typeof trackingThematiqueInfoSelector
>;

export type StoredRushHour = InputType<
  GraphQLTypes['RushHour'],
  typeof rushHourSelector
>;

export type StoredTrackingPassedTimeByThematique = InputType<
  GraphQLTypes['TrackingPassedTimeByThematique'],
  typeof trackingPassedTimeByThematiqueSelector
>;

export type StoredResponse = InputType<
  GraphQLTypes['Response'],
  typeof responseSelector
>;
